export const MY_ACCOUNT_TEXT = {
  'account.my_account_title': {
    'en-GB': 'My Account | Moonpig',
    'nl-NL': 'Mijn Account | Greetz',
  },
  'account.my_orders': {
    'en-GB': 'Orders',
    'nl-NL': 'Bestellingen',
  },
  'account.my_account_details': {
    'en-GB': 'Account Details',
    'nl-NL': 'Accountgegevens',
  },
  'account.my_saved_payment_cards': {
    'en-GB': 'Saved Payment Methods',
    'nl-NL': 'Mijn opgeslagen betaalkaarten',
  },
  'account.my_address_book': {
    'en-GB': 'Address Book',
    'nl-NL': 'Adresboek',
  },
  'account.my_group_cards': {
    'en-GB': 'My Group Cards',
    'nl-NL': 'Mijn groepskaarten',
  },
  'account.my_reminders': {
    'en-GB': 'My Reminders',
    'nl-NL': 'Mijn kalender',
  },
  'account.my_favourites': {
    'en-GB': 'My Favourites',
    'nl-NL': 'Mijn favorieten',
  },
  'account.page_favourites': {
    'en-GB': 'My Favourites | Moonpig',
    'nl-NL': 'Mijn favorieten | Greetz',
  },
  'account.favourites': {
    'en-GB': 'favourites',
    'nl-NL': 'favorieten',
  },
  'account.sign_out': {
    'en-GB': 'Sign Out',
    'nl-NL': 'Afmelden',
  },
  'account.moonpig_plus': {
    'en-GB': 'Moonpig Plus Benefits',
    'nl-NL': 'Greetz Plus voordelen',
  },
  'account.moonpig_plus_valid_until': {
    'en-GB': 'Valid until',
    'nl-NL': 'Geldig tot',
  },
  'account.hey': {
    'en-GB': 'Hey',
    'nl-NL': 'Hallo',
  },
  'account.nice_to_see_you': {
    'en-GB': `It’s nice to see you, come on in...`,
    'nl-NL': `Leuk je te zien, welkom...`,
  },
  'account.welcome_back': {
    'en-GB': `Welcome back`,
    'nl-NL': `Leuk je te zien, welkom...`,
  },
  'account.reminder_birthday': {
    'en-GB': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s birthday is in ${
        c.daysUntil
      } ${getDaysPluralStringEnglish(c.daysUntil)}!`,
    'nl-NL': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s verjaardag is over ${
        c.daysUntil
      } ${getDaysPluralStringDutch(c.daysUntil)}!`,
  },
  'account.reminder_anniversary': {
    'en-GB': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s anniversary is in ${
        c.daysUntil
      } ${getDaysPluralStringEnglish(c.daysUntil)}!`,
    'nl-NL': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s jubileum is over ${
        c.daysUntil
      } ${getDaysPluralStringDutch(c.daysUntil)}!`,
  },
  'account.reminder_christmas': {
    'en-GB': (c: { daysUntil: number }) =>
      `Christmas is in ${c.daysUntil} ${getDaysPluralStringEnglish(
        c.daysUntil,
      )}!`,
    'nl-NL': (c: { daysUntil: number }) =>
      `Kerst is over ${c.daysUntil} ${getDaysPluralStringDutch(c.daysUntil)}!`,
  },
  'account.reminder_fathers_day': {
    'en-GB': (c: { daysUntil: number }) =>
      `Father's Day is in ${c.daysUntil} ${getDaysPluralStringEnglish(
        c.daysUntil,
      )}!`,
    'nl-NL': (c: { daysUntil: number }) =>
      `Vaderdag is over ${c.daysUntil} ${getDaysPluralStringDutch(
        c.daysUntil,
      )}!`,
  },
  'account.reminder_mothers_day': {
    'en-GB': (c: { daysUntil: number }) =>
      `Mother's Day is in ${c.daysUntil} ${getDaysPluralStringEnglish(
        c.daysUntil,
      )}!`,
    'nl-NL': (c: { daysUntil: number }) =>
      `Moederdag is over ${c.daysUntil} ${getDaysPluralStringDutch(
        c.daysUntil,
      )}!`,
  },
  'account.reminder_just_a_note': {
    'en-GB': (c: { recipientName: string; daysUntil: number }) =>
      `Just a note to say thank you to ${c.recipientName} in ${
        c.daysUntil
      } ${getDaysPluralStringEnglish(c.daysUntil)}!`,
    'nl-NL': (c: { recipientName: string; daysUntil: number }) =>
      `Bedank ${c.recipientName} over ${c.daysUntil} ${getDaysPluralStringDutch(
        c.daysUntil,
      )}!`,
  },
  'account.reminder_new_baby': {
    'en-GB': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s new baby is in ${
        c.daysUntil
      } ${getDaysPluralStringEnglish(c.daysUntil)}!`,
    'nl-NL': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s nieuwe baby is over ${
        c.daysUntil
      } ${getDaysPluralStringDutch(c.daysUntil)}!`,
  },
  'account.reminder_special_occasion': {
    'en-GB': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s special occasion is in ${
        c.daysUntil
      } ${getDaysPluralStringEnglish(c.daysUntil)}!`,
    'nl-NL': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s speciaal moment is over ${
        c.daysUntil
      } ${getDaysPluralStringDutch(c.daysUntil)}!`,
  },
  'account.reminder_valentines': {
    'en-GB': (c: { recipientName: string; daysUntil: number }) =>
      `Valentine's Day for ${c.recipientName} is in ${
        c.daysUntil
      } ${getDaysPluralStringEnglish(c.daysUntil)}!`,
    'nl-NL': (c: { recipientName: string; daysUntil: number }) =>
      `Valentijnsdag voor ${c.recipientName} is over ${
        c.daysUntil
      } ${getDaysPluralStringDutch(c.daysUntil)}!`,
  },
  'account.reminder_wedding': {
    'en-GB': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s wedding is in ${
        c.daysUntil
      } ${getDaysPluralStringEnglish(c.daysUntil)}!`,
    'nl-NL': (c: { recipientName: string; daysUntil: number }) =>
      `${c.recipientName}'s bruiloft is over ${
        c.daysUntil
      } ${getDaysPluralStringDutch(c.daysUntil)}!`,
  },
  'account.start_shopping': {
    'en-GB': `Start Shopping`,
    'nl-NL': `Onze aanbevelingen`,
  },
  'account.business': {
    'en-GB': 'Moonpig for business',
    'nl-NL': 'Moonpig for business',
  },
  'account.pig': {
    'en-GB': 'Pig',
    'nl-NL': 'Varken',
  },
}

const getDaysPluralStringEnglish = (day: number) => {
  return day > 1 ? `days` : `day`
}

const getDaysPluralStringDutch = (day: number) => {
  return day > 1 ? `dagen` : `dag`
}
